import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 80; // Adjust this value based on your header's actual height
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h3 className="text-xl font-semibold mb-4">{t('footer.about')}</h3>
            <p className="text-gray-400">{t('footer.description')}</p>
          </div>
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h3 className="text-xl font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-400 hover:text-white transition-colors" onClick={(e) => handleClick(e, '#home')}>{t('footer.home')}</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-white transition-colors" onClick={(e) => handleClick(e, '#about')}>{t('footer.about')}</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-white transition-colors" onClick={(e) => handleClick(e, '#services')}>{t('footer.services')}</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors" onClick={(e) => handleClick(e, '#contact')}>{t('footer.contact')}</a></li>
            </ul>
          </div>
          <div className="w-full md:w-1/3">
            <h3 className="text-xl font-semibold mb-4">{t('footer.contact')}</h3>
            <p className="text-gray-400 mb-2">{t('footer.address')}</p>
            <p className="text-gray-400 mb-2">{t('footer.phone')}</p>
            <p className="text-gray-400">{t('footer.email')}</p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">&copy; {new Date().getFullYear()} eAlice. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;